import axios from 'axios'
import type { GetMccGroupListResponse } from 'src/queries/mccGroups.queries'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getMccGroups = async (): Promise<GetMccGroupListResponse> =>
  getResponseData(
    axios.get<GetMccGroupListResponse>(
      `/mccgroups`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
